import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Checkbox from '../../../form/component/Checkbox'
import currentUserHasAccess from '../../../../util/widget-helper'
import {MODEL_SELECTION_WIDGET} from '../../../process/ui-definition/process-ui'
import store from "../../../store";
import {selectProcessInstance} from "../../../process/state/instance-detail/selector";

const MODEL_SELECTION_PROPERTY = 'modelSelection'

const MODEL_SELECTION_PROPERTY_RE_PRODUCTION = 'modelSelectionReproduction'

function getAlignerSelectionObject(processContext, modelSelectionProcessContextKey) {
    if (!processContext) {
        return {}
    }

    return processContext[modelSelectionProcessContextKey] || {}
}

let alignerTypeSelectionsReadOnly = {};

function setReadOnlyStatusForAlignerTypeSections(selectedAlignerList, alignerLabelList) {
    clearReadOnlyStatusForAlignerTypeSections(alignerLabelList);

    Object.keys(selectedAlignerList).forEach(function (selectedAlignerName) {
        alignerLabelList.forEach(function ({labelList, salesOrderReference}, alignerLabelKey) {
            labelList.forEach(function ({lower, upper}) {
                let lowerLabelName = generateLowerAlignerName(lower, salesOrderReference);
                let upperLabelName = generateUpperAlignerName(upper, salesOrderReference);

                if ([upperLabelName, lowerLabelName].includes(selectedAlignerName)) {
                    Object.keys(alignerTypeSelectionsReadOnly).forEach(function (key) {
                        if (parseInt(key, 10) !== alignerLabelKey && selectedAlignerList[selectedAlignerName] === true) {
                            alignerTypeSelectionsReadOnly[key] = true;
                        }
                    });
                }
            });
        });
    });
}

function clearReadOnlyStatusForAlignerTypeSections(alignerLabelList) {
    Object.keys(alignerLabelList).forEach(function (key) {
        alignerTypeSelectionsReadOnly[key] = false;
    });
}

function generateLowerAlignerName(lower, salesOrderReference) {
    return getSalesOrderReferenceShort(salesOrderReference) + lower;
}

function generateUpperAlignerName(upper, salesOrderReference) {
    return getSalesOrderReferenceShort(salesOrderReference) + upper;
}

function getSalesOrderReferenceShort(salesOrderReference) {
    const referenceNumberPartList = salesOrderReference.split('-');
    return referenceNumberPartList[2];
}

const ModelSelection = ({ treatmentPlan, alignerLabelList, readOnly, processContext, changeProcessContext, saveProcessContext }) => {
    let modelSelectionProcessContextKey = MODEL_SELECTION_PROPERTY;

    if (!currentUserHasAccess(MODEL_SELECTION_WIDGET)) {
        return null
    }

    if (!treatmentPlan) {
        return null
    }

    const state = store.getState()
    const processInstance = selectProcessInstance(state)
    const isAlignerReproductionProcess = (processInstance && processInstance.processName === 'salesorder-aligner-reproduction')

    if (isAlignerReproductionProcess) {
        modelSelectionProcessContextKey = MODEL_SELECTION_PROPERTY_RE_PRODUCTION;
    }

    // change selection
    const alignerSelectionObject = getAlignerSelectionObject(processContext, modelSelectionProcessContextKey)

    const toggleAlignerSelection = (name, salesOrderReference) => {
        changeProcessContext(modelSelectionProcessContextKey, {
            ...alignerSelectionObject,
            [name]: !alignerSelectionObject[name],
        })
        changeProcessContext('SalesOrderReference', salesOrderReference)
        saveProcessContext()
    }

    // select all aligner/models
    const selectAll = (selected) => {
        let selection = {}

        let lastAlignerLabel = alignerLabelList[alignerLabelList.length - 1]

        const referenceNumberPartList = lastAlignerLabel.salesOrderReference.split('-')

        //take the last Part of SalesOrderReferenceNumber e.g: A-2020-f543 --> f543
        const salesOrderReferenceShort = referenceNumberPartList[2]

        lastAlignerLabel.labelList.map((label) => {
            if (label.upper) {
                selection[salesOrderReferenceShort + label.upper] = selected
            }
            if (label.lower) {
                selection[salesOrderReferenceShort + label.lower] = selected
            }

            return selection
        })

        changeProcessContext(modelSelectionProcessContextKey, selection)
        saveProcessContext()
    }

    if (alignerSelectionObject && alignerLabelList) {
        setReadOnlyStatusForAlignerTypeSections(alignerSelectionObject, alignerLabelList)
    }

    return (
        <ContentBox title="Model Selection">
            {!readOnly && (
                <div>
                    <button
                        className="btn btn-warning btn-sm"
                        onClick={() => {
                            selectAll(true)
                        }}>
                        <i className="fa fa-play"/>
                        &#160;Select all
                    </button>
                    &#160;&#160;
                    <button
                        className="btn btn-warning btn-sm"
                        onClick={() => {
                            selectAll(false)
                        }}>
                        <i className="fa fa-play"/>
                        &#160;Deselect all
                    </button>
                </div>
            )}
            {
                alignerLabelList.map((alignerLabel, index1) => {
                    return <div style={{ marginTop: '20px' }} key={index1}>
                        <div><h3>
                            <b>{alignerLabel.salesOrderType.charAt(0).toUpperCase() + alignerLabel.salesOrderType.slice(1)}</b>
                        </h3></div>
                        <table className="default-table">
                            <thead>
                            <tr>
                                <th>Upper</th>
                                <th>Lower</th>
                            </tr>
                            </thead>
                            <tbody>
                            {(alignerLabel.labelList.map((label, index2) => {
                                    // prepare for aligner rendering
                                    const referenceNumberPartList = alignerLabel.salesOrderReference.split('-')
                                    const salesOrderReferenceShort = referenceNumberPartList[2]

                                    const renderAlignerLabel = (label) => {
                                        return label ? salesOrderReferenceShort + label : ''
                                    }

                                    const upperText = renderAlignerLabel(label.upper)
                                    const lowerText = renderAlignerLabel(label.lower)
                                    return (
                                        <tr key={index2}>
                                            <td>
                                                {upperText && (
                                                    <Checkbox
                                                        readOnly={readOnly || alignerTypeSelectionsReadOnly[index1]}
                                                        name={upperText}
                                                        object={alignerSelectionObject}
                                                        onChange={(name, value) => {
                                                            if (!readOnly) {
                                                                toggleAlignerSelection(name, alignerLabel.salesOrderReference)
                                                            }
                                                        }}
                                                    >
                                                        {upperText}
                                                    </Checkbox>
                                                )}
                                            </td>
                                            <td>
                                                {lowerText && (
                                                    <Checkbox
                                                        readOnly={readOnly || alignerTypeSelectionsReadOnly[index1]}
                                                        name={lowerText}
                                                        object={alignerSelectionObject}
                                                        onChange={(name, value) => {
                                                            if (!readOnly) {
                                                                toggleAlignerSelection(name, alignerLabel.salesOrderReference)
                                                            }
                                                        }}
                                                    >
                                                        {lowerText}
                                                    </Checkbox>

                                                )}</td>
                                        </tr>)
                                })
                            )}</tbody>
                        </table>
                    </div>
                })
            }
        </ContentBox>
    )
}

ModelSelection.propTypes = {
    treatmentPlan: PropTypes.object.isRequired,
    readOnly: PropTypes.bool,
}

export default ModelSelection



// WEBPACK FOOTER //
// ./src/modules/treatment/component/plan/ModelSelection.js